<template>
  <donut-chart96-template
    :board-ids="[628, 629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639]"
    :data-type="dataType"
    :graph-id="96"
    title="공중이용시설 안전인력 운용현황"
    unit="명"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart89Template from "@/views/graph/DonutChart89Template.vue";
import DonutChart96Template from "@/views/graph/DonutChart96Template.vue";

export default {
  name: 'DonutChart96',
  components: {DonutChart96Template, DonutChart89Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
